export default {
  title: "Типы застройки",
  exhibitArea: {
    areaType: "Типы выставочной площади",
    closed: "Закрытая",
    opened: "Открытая",
    closedArea: "Закрытая площадь",
    openedArea: "Открытая площадь",
    closedAreaDescr:
      "выставочная площадь, находящаяся в зале\n" + "            павильона.",
    openedAreaDescr:
      "выставочная площадь, находящаяся на улице\n" +
      "            у павильона.",
    unequipped: "Необорудованная",
    equipped: "Оборудованная",
    unequippedArea: "Необорудованная площадь",
    equippedArea: "Оборудованная площадь",
    unequippedAreaDescr:
      "выставочная закрытая или открытая\n" +
      "            площадь без стенда («голый пол»). Участник нанимает компанию-\n" +
      "            застройщика для строительства стенда.",
    equippedAreaDescr:
      "выставочная закрытая площадь со\n" +
      "            стендом, оборудованным определенным набором мебели."
  },
  buildingType: {
    title: "Типы застройки",
    standart: "Стандартная",
    standartDescr:
      " В зависимости от выставки стандартный тип застройки отличается как по\n" +
      "          дизайну, так и по комплектации стенда.",
    exclusive: "Эксклюзивная",
    exclusiveDescr:
      "Индивидуальная, нестандартная застройка по эксклюзивному проекту"
  },
  stand: {
    title: "Пример комплектации стандартного стенда",
    subtitle: "Дизайн и комплектация стенда зависит от конкретной выставки"
  },
  table: {
    thead1: "Комплектация стандартного стенда (кв.м.)",
    thead2: "Ед. изменения",
    tr1thead1: "Подсобное помещение с дверью",
    tr1thead2: "Кв. м",
    tr1thead3: "нет",
    tr2thead1: "Фризовая панель высотой 0,3 м",
    tr2thead2: "Шт",
    tr2thead3: "1+1 угол",
    tr2thead4: "1+1 угол",
    tr3thead1: "Освещение общей площади стенда",
    tr3thead2: "Шт",
    tr3thead3: " Из расчета 1 спот на 3 кв. м площади.",
    tr4thead1: "Розетка тройник 1 kW",
    tr5thead1: "Информационная стойка высотой 1,1 м",
    tr6thead1: "Витрина высотой 2,5 м (1х0,5)",
    tr7thead1: "Витрина высотой 1,1 м (1х0,5)",
    tr8thead1: "Стол круглый D0,7 м, 0,7х0,7 м, 1,2х0,7м (на выбор)",
    tr9thead1: "Стул переговорный",
    tr10thead1: "Корзина для бумаг",
    tr11thead1: "Вешалка настенная",
    info1: "Ковровое покрытие (цвет на выбор: серый, синий, красный, зеленый);",
    info2: "Фризовая панель с надписью на одном языке."
  },
  addInfo: {
    examples: "Варианты застроек",
    infotitle: "Важная информация",
    contactDetailsTitle:
      "  Контакты генерального застройщика ООО «Экспоконста»",
    mainBuilder: "Генеральный застройщик AO «Экспоцентр»:",
    info1: "ООО «Экспоконста»",
    info2: " Адрес: Россия, 123100, Москва, 1-й Красногвардейский проезд, 1 ",
    info3: "Тел.:",
    info4: "Факс:",
    info5: "Сайт:",
    info6:
      "Перечень дополнительного оборудования, которое заказывается и\n" +
      "          оплачивается отдельно, представлен в разделе",
    info7: " «Оборудование»",
    info8: " на этой странице.",
    rulesServiceTitle: "Правила организации работ застройщиков",
    info9:
      " Правила организации работ застройщиков выставочных стендов и\n" +
      "              экспозиций на территории Центрального выставочного комплекса\n" +
      "              «ЭКСПОЦЕНТР»",
    info10:
      "В случае осуществления экспонентом застройки арендованной площади\n" +
      "          самостоятельно или с привлечением внешних фирм-застройщиков необходимо\n" +
      "          пройти в ООО «Экспоконста»",
    info11: "ТЕХНИЧЕСКИЙ КОНТРОЛЬ",
    info12:
      "Проект строительства стенда должен быть согласован с пожарным надзором\n" +
      "          на AO «Экспоцентр»",
    info13: " Пожарный надзор",
    info14: " Организация, оказывающая услуги в области пожарной безопасности",
    info15: " Для согласования необходимо представить следующие документы:",
    info16: " письмо с перечнем материалов, применяемых при монтаже стендов;",
    info17: "план стенда;",
    info18:
      "   сертификаты пожарной безопасности Российской Федерации на материалы,\n" +
      "            используемые при монтаже стендов;",
    info19:
      "   акты огнезащитной обработки горючих материалов (в случае применения\n" +
      "            материалов с пожарно-техническими характеристиками соответствующими\n" +
      "            требованиям нормативных документов в области пожарной безопасности);",
    info20: "копию лицензии организации осуществлявшей огнезащитную обработку;",
    info21:
      "  копии сертификата пожарной безопасности, сертификата соответствия,\n" +
      "            гигиенического сертификата на огнезащитный состав."
  }
};
